import React, { useState } from 'react'
import { connect } from 'react-redux'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import ConsultaPorCosechaView from '../../components/controlExistencias/ConsultaPorCosechaView'
import { obtenerCosultaPorCosecha } from '../../actions/listados'

function ConsultaPorCosecha (props) {
  const { obtenerCosultaPorCosecha } = props
  const [show, setShow] = useState(false)

  const actualizarFechas = (fechaD, fechaH) => {
    obtenerCosultaPorCosecha(fechaD, fechaH)
    setShow(true)
  }

  return (
    <>
      <h4 style={{ marginTop: '-2%' }}>Consulta por cosecha</h4>
      <div className='container-entre-fechas' style={{ margin: 'auto' }}>
        <DatePicker
          selectRange
          disabledFuture
          locale='es'
          onDateChange={actualizarFechas}
          titulo='Seleccione las fechas'
          value='fechas'
        />
      </div>

      { show && <ConsultaPorCosechaView /> }
    </>
  )
}

const mapActionsToProps = {
  obtenerCosultaPorCosecha
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(ConsultaPorCosecha)
